module.exports = __webpack_public_path__ + "media/application/images/svgs/moon-2cb5c41da906b4208a32b10472801452.svg";